/* eslint-disable max-len */
/* eslint-disable arrow-body-style */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import { Parser } from 'html-to-react';
import draftToHtml from 'draftjs-to-html';
import AreaCarousel from './Carousel/AreaCarousel';
import { fetchAboutMunicipalityData } from '../Actions/AboutMunicipalityActions';
import { closeCommuteModal, openCommuteModal } from '../Actions/ToggleActions';
import { SECTION_TYPE, URL_TYPES, FETCH_STATUS } from '../Constants';
import LoadingIndicatorComponent from './LoadingIndicatorComponent';
import EmbeddedVideoComponent from './EmbeddedVideoComponent';
import ImageSectionComponent from './ImageSectionComponent';
import FAQComponent from './FAQComponent';
import { setPageTitle, capitalize } from '../Utils/otherUtils';

const AboutMunicipality = () => {
  const dispatch = useDispatch();
  const {
    language,
    text: { municipalityPage: pageText },
  } = useSelector(state => state.Language);
  const municipality = useSelector(state => state.MunicipalityReducer);
  const aboutMunicipality = useSelector(state => state.AboutMunicipalityReducer);
  const { areas } = useSelector(state => state.AreaReducer);

  const htmlToReactParser = new Parser();

  useEffect(() => {
    dispatch(closeCommuteModal());
  }, []);

  useEffect(() => {
    if (municipality.status === FETCH_STATUS.SUCCEEDED) {
      setPageTitle(`${pageText.pageTitle} ${capitalize(municipality.name)}`);
      if (!municipality.languages.includes(language.toUpperCase())) {
        dispatch(push(`/sv/${municipality.name}/${URL_TYPES.ABOUT_MUNICIPALITY}`));
      } else {
        dispatch(fetchAboutMunicipalityData(municipality.name));
      }
    }
  }, [municipality.status]);

  const parseTextSection = (section) => {
    const textToParse = section.content[language];
    return (
      <div key={section.index} className="main-text-content">
        <p><strong>{textToParse.header}</strong></p>
        {htmlToReactParser.parse(draftToHtml(textToParse.text))}
      </div>
    );
  };

  const parseSections = (sections) => {
    return sections.map((section) => {
      const divider = section.index !== sections.length;
      switch (section.type) {
        case SECTION_TYPE.TEXT:
          return parseTextSection(section);
        case SECTION_TYPE.IMAGES:
          return (<ImageSectionComponent
            municipality={municipality.name}
            section={section}
            divider={divider}
            key={section.index}
          />);
        case SECTION_TYPE.VIDEO:
          return (<EmbeddedVideoComponent
            section={section}
            key={section.index}
          />);
        case SECTION_TYPE.FAQ:
          return (<FAQComponent
            content={section.content[language]}
            divider={divider}
            key={section.index}
          />);
        default:
          return '';
      }
    });
  };

  const renderSections = () => {
    const sortedSections = aboutMunicipality.data.content && municipality.initialMapState
      ? aboutMunicipality.data.content.section.sort((s1, s2) => s1.index - s2.index) : null;
    const sections = sortedSections && municipality.initialMapState ? parseSections(sortedSections) : null;

    return (
      <div className="white-bg">
        <div className="top-btn">
          <input
            className="btn close"
            type="button"
            onClick={() => { dispatch(goBack()); dispatch(openCommuteModal()); }}
          />
        </div>
        <div className="header">
          <h1>{aboutMunicipality.data.content.topContent[language].header}</h1>
        </div>
        <div className="preamble main-text-content">
          {htmlToReactParser.parse(draftToHtml(aboutMunicipality.data.content.topContent[language].text))}
        </div>
        <div>
          {sections}
        </div>
        <div>
          <hr className="divider" />
          <AreaCarousel
            areas={areas}
          />
        </div>
      </div>
    );
  };

  return (
    <article className="full-view-page-wrapper" aria-label={pageText.aboutMunicipality}>
      {aboutMunicipality.status === FETCH_STATUS.SUCCEEDED ? renderSections() : (
        <LoadingIndicatorComponent />
      )}
    </article>
  );
};

export default AboutMunicipality;



// WEBPACK FOOTER //
// ./src/Components/AboutMunicipality.js